import { SetState } from "shared/types/general";
import React, { memo, useCallback } from "react";
import { IMaskInput } from "react-imask";
import s from "./style.module.scss";

interface InputProps {
  label?: string;
  id?: string;
  type?: string;
  value: string;
  setValue: SetState<string>;
  placeholder?: string;
  mask: any;
  disabled?: boolean;
  children?: React.ReactNode;
  className?: string;
}

const Input: React.FC<InputProps> = memo(
  ({
    mask,
    setValue,
    value,
    children,
    className = "",
    disabled = false,
    id = "",
    label,
    placeholder,
    type = "text",
  }) => {
    const handleChange = useCallback(
      (e: React.ChangeEvent<HTMLInputElement>) => setValue(e.target.value),
      []
    );

    return (
      <div className={`${s.input} ${className}`}>
        {label && <label htmlFor={id}>{label}</label>}
        <IMaskInput
          mask={mask}
          radix="."
          placeholder={placeholder}
          type={type}
          id={id}
          onAccept={(value) => setValue(value)}
          value={value}
          disabled={disabled}
        />
        {children}
      </div>
    );
  }
);

export default Input;
